import React from 'react';
import Card from "olive-react-myoneui/lib/Card";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import { arrowsFullScreenIcon, cancelFullScreenIcon } from "../../../constants/icons";

const CoursePlay = ({
  className,
  videoSrc,
  imgSrc,
  title,
  onFullScreenClick,
  defaultImg
}) => {
  return (
    <Card className={`${className} myk__stu-course-play border-0 bg-transparent`}>
      <Card.Body className="p-0">
        <div className="myk__stu-course-header">
          <Row>
            <Col lg={10}>
                <h2>{title}</h2>
            </Col>
            {onFullScreenClick &&
              <Col lg={2} className="d-flex align-items-center justify-content-end">
                  <div className="btn-fullscreen" role="button" onClick={onFullScreenClick}>
                      {arrowsFullScreenIcon}{cancelFullScreenIcon}
                  </div>
              </Col>
            }
          </Row>
        </div>
        <Row>
            {videoSrc && 
            <Col lg={12}>
                <div className="myk__stu-course-video-wrapper">
                    <video className="object-fit-cover w-100" controls autoPlay>
                        <source src={videoSrc} type="video/mp4" />
                        <source src={videoSrc} type="video/ogg" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </Col>
            }
            {imgSrc && 
            <Col lg={12}>
                <div className="myk__stu-course-video-wrapper">
                  <img src={imgSrc} onError={(e) => (e.target.src = defaultImg)} alt={title} />
                  <img src={imgSrc} onError={(e) => (e.target.src = defaultImg)} alt={title} class="shadow-img"/>  
                </div>
            </Col>
            }
        </Row>
      </Card.Body>
    </Card>
  );
}

export default CoursePlay;
